"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageSessionManager = void 0;
var UrlParser_1 = __importDefault(require("../Utils/UrlParser"));
var LocalStorageSessionManager = /** @class */ (function () {
    function LocalStorageSessionManager() {
        this.expirationTimeInMinutes = 30;
    }
    LocalStorageSessionManager.prototype.getToken = function () {
        if (!this.tokenIsExpired())
            return this.get(this.generateTokenKey());
        return "";
    };
    LocalStorageSessionManager.prototype.setToken = function (token) {
        this.set(this.generateTokenKey(), token);
        this.set(this.generateExpirationKey(), this.calculateExpirationTimestamp().toString());
    };
    LocalStorageSessionManager.prototype.refreshToken = function () {
        return "";
    };
    LocalStorageSessionManager.prototype.set = function (key, value) {
        localStorage.setItem(key, value);
    };
    LocalStorageSessionManager.prototype.get = function (key) {
        return localStorage.getItem(key);
    };
    LocalStorageSessionManager.prototype.generateTokenKey = function () {
        var domain = new UrlParser_1.default(document.location.href).getHost();
        return window.btoa(domain);
    };
    LocalStorageSessionManager.prototype.generateExpirationKey = function () {
        return "x_" + this.generateTokenKey();
    };
    /**
     * Calculate ex time
     */
    LocalStorageSessionManager.prototype.calculateExpirationTimestamp = function () {
        return new Date().getTime() + this.expirationTimeInMinutes * 60000;
    };
    /**
     * Check if token is expired
     */
    LocalStorageSessionManager.prototype.tokenIsExpired = function () {
        var expirationTime = +this.get(this.generateExpirationKey());
        return isNaN(+expirationTime) || +expirationTime < +new Date().getTime();
    };
    return LocalStorageSessionManager;
}());
exports.LocalStorageSessionManager = LocalStorageSessionManager;
exports.default = LocalStorageSessionManager;
